import { render, staticRenderFns } from "./HighImportanceNotifications.vue?vue&type=template&id=6a682b7d&scoped=true"
import script from "./HighImportanceNotifications.vue?vue&type=script&lang=js"
export * from "./HighImportanceNotifications.vue?vue&type=script&lang=js"
import style0 from "./HighImportanceNotifications.vue?vue&type=style&index=0&id=6a682b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a682b7d",
  null
  
)

export default component.exports